export const GIVEAWAY_STATUSES = ['draft', 'active', 'closed', 'winner_selected'];

export const GIVEAWAY_STATUS_OPTIONS = GIVEAWAY_STATUSES.map((value) => ({
  value,
  label: value.replace('_', ' ').replace(/\b\w/g, (char) => char.toUpperCase()),
}));

export function getGiveawayStatusColor(status) {
  switch (status) {
    case 'active':
      return 'green';
    case 'closed':
      return 'orange';
    case 'winner_selected':
      return 'blue';
    case 'draft':
    default:
      return 'default';
  }
}

export function canSelectWinner(status) {
  return status === 'active' || status === 'closed';
}

/**
 * Whether admin may still pick winners for this campaign.
 * Locked when selection is complete or status forbids it.
 * Supports selecting 1 winner or multiple up to remaining slots (campaign.winnerCount).
 */
export function canSelectWinnersForCampaign(campaign) {
  if (!campaign) return false;
  if (campaign.selectionComplete === true) return false;
  if (campaign.status === 'winner_selected') return false;
  return canSelectWinner(campaign.status);
}
